import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=0238d210&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0238d210')) {
      api.createRecord('0238d210', component.options)
    } else {
      api.reload('0238d210', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=0238d210&", function () {
      api.rerender('0238d210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bQye5LDXI9qI/JS/comp/ImgFallback.vue"
export default component.exports